module.exports = __webpack_public_path__ + "assets/img/404.6428c3ec.png";